import { Button, Form, FormGroup, Label, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Card, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

import {  useState, useCallback } from "react"
import Breadcrumbs from "../../coreComponents/breadcrumbs"
import CommonCardHeader from "../../coreComponents/CommonCardHeader"
import { useAppSelector } from "../../reduxToolkit/hooks"
import Table from "../table/Table"
import ApiService from "../../services/apiService"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { usePagination } from "../../hooks/usePagination"
import RightIcon from "../svg/RightIcon"
import LeftIcon from "../svg/LeftButton";
import FilterIcon from "../svg/FilterIcon"
import { format } from "date-fns";
import LoadingComponent from "../lodingComponent"
import { Filter } from "react-feather"

const OmsList = () => {

   let updatedData :any =[] 


   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
   const role = useAppSelector((state) => state.role.role)
   const [omsData, setOmsData] = useState<any>([])
   const navigate = useNavigate();
   const [selectedId, setSelectedId] = useState<any>();

   const {
      data,
      pageNumber,
      setPageNumber,
      pageSize,
      totalCount,
      setRefresh,
      setSearchQuery,
      searchQuery,
      filterOn,
      setSortBy,
      loading
   } = usePagination({
      endpoint: `/chack`,
      filterOn:'ChackName',
      enabled:true
     
   })
   const totalPages = Math.ceil(totalCount / pageSize);

   const handleNext = useCallback(() => {
      setPageNumber((prev) => Math.min(totalPages, prev + 1))
   }, [setPageNumber, totalPages])



   const handlePrev = useCallback(() => {
      setPageNumber((prev) => Math.max(1, prev - 1))
   }, [setPageNumber, totalPages])

   if(data){
         
       updatedData = data.map((time) =>{
       const formatDate =format(new Date(time.dateTime),'yyyy-MM-dd HH:mm:ss')
       return{
          ...time,
          dateTime:formatDate
       }
})
}
    
   

   const handleDelete = (id: string) => {
      setSelectedId(id)
   }

   const handleUpdate = (id: string) => {
      navigate(`/oms-update${id}`)
   }

   const handleDeleteOms = async (id: string) => {

      try {
         const response = await ApiService.axiosApi(`/oms/deleteoms${id}`, {
            method: 'DELETE'
         })
         if (response.success) {
            toast.success("OMS deleted sucessfully")
         } else {
            console.log(response.message || response.status || "unable to delte oms")
         }
      } catch (error) {
         console.log(error)
      }
   }

   return (

      <>
         <Breadcrumbs mainTitle={"OmsList"} parent={"Oms"} />
       
            <Card>
               <CommonCardHeader title="Oms List" headClass="pb-3" />
               <div className="d-flex justify-content-between pb-2">
               <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                        <div>
                        <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                      
                        />
                        </div>
                           <div>
                           <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('ChackName')}>
                           <Filter/>
                       </button>
                           </div>
                        
                    </div>
               {role === "Administrator" && (
                  <div className="d-flex justify-content-end">

                  </div>
               )}
               </div>
                {loading?<LoadingComponent/>: <Table
               isAction={false}
                  data={updatedData}
                  columns={[
                     { header: "Chak Name", accessor: "chackName" },
                     { header: "No. On/Of Valves", accessor: "no_Of_ON_OF_Valves" },
                     { header: "Distrbutary/Zone", accessor: "distributary_Zone" },
                     { header: "Scheme/Village", accessor: "scheme_Village" },
                     { header: "Duty", accessor: "duty" },
                     { header: "Updated Time", accessor: "dateTime" },
                     { header: "Pressure", accessor: "pressure" },
                     { header: "FlowRate", accessor: "flowRate" },
                     { header: "Today Volume", accessor: "todayVolume" },
                     { header: "On Valves", accessor: "onValves" },
                     { header: "Door1", accessor: "door1" },
                     { header: "Door2", accessor: "door2" },
                     { header: "Network Status", accessor: "networkStatus" },
                     { header: "Battery Status", accessor: "battery" },
                     { header: "Solar Voltage", accessor: "solarVoltage" },
                     { header: "Temprature", accessor: "temprature" },
                     { header: "Water Meter", accessor: "waterMeter" },
                     { header: "Roms Auto", accessor: "romsAuto" },
                  ]}
                  buttons={[

                  ]

                  }
               />}
              
               <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                  <p style={{ marginRight: '10px', marginTop: '8px' }}>
                     Page {pageNumber} of {totalPages}
                  </p>
                  <button
                     onClick={handlePrev}
                     disabled={pageNumber === 1}
                     className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                  >
                     <LeftIcon className="icon" />
                  </button>
                  <button
                     className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                     onClick={handleNext}
                     disabled={pageNumber === totalPages}
                  >
                     <RightIcon className="icon" />
                  </button>
               </div>
            </Card>
            <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
               <ModalHeader>Delete Distributary</ModalHeader>
               <ModalBody>Are you sure you want to delete this distributary?</ModalBody>
               <ModalFooter>
                  <Button color="danger" onClick={() => handleDeleteOms(selectedId)}>Delete</Button>
                  <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
               </ModalFooter>
            </Modal>
        
      </>
   )

}
export default OmsList;